// Exported so the hand-rolled team shapes scattered across features can pick up
// the field they all need — miss it and the logo silently renders blank.
export type TeamLogoSource = {
  logoUrl?: string | null;
};

// Unlike `getLeagueLogo`, which builds its URL from `assetsBaseUrl`, team logo URLs
// come ready-made from business-api: it holds the CDN origin and the bucket layout,
// and does not ship `logoId`/`teamLogoExtension`, so there is nothing to rebuild from.
export const getTeamLogoUrl = (team: TeamLogoSource | null | undefined): string =>
  team?.logoUrl ?? '';

// Logos range from ~0.7 (tall crests) to ~2.3 (wide wordmarks) width/height, so a
// square box + `contain` renders the wide ones visibly shorter. Pin the height and
// let the width follow; `maxWidth` stops a wordmark from blowing out its row.
// Works as both an MUI `sx` and a plain `style` object.
export const teamLogoSize = (height: number, maxWidth: number | string = height * 2.5) => ({
  height,
  width: 'auto',
  maxWidth,
  objectFit: 'contain' as const,
});
